import { Colors } from 'library';
import { Card, Grid, Link, PillButton, Row, Stack, Text, Title } from 'library/ui';
import React, { useState } from 'react';
import { useMediaQuery } from '@mui/material';
import { formatMonthDayYearWith12HourTime } from 'shared/Dates';
import { client, consoleLogInDev } from 'shared';
import { ISentHomeAppointment } from 'models';
import theme from 'theme';
import { SentHomeDisputeModal } from './SentHomeDisputeModal';

interface SentHomeCancelsProps {
    overallReasons: ISentHomeAppointment[];
    refreshReasons: () => void;
}

export default function SentHomeCancels({ overallReasons, refreshReasons }: SentHomeCancelsProps) {
    const [disputeId, setDisputeId] = useState<number>();
    const [disputeName, setDisputeName] = useState('');

    const isXs = useMediaQuery(theme.breakpoints.down('sm'));

    function onConfirmOrDenyClick(id: number, sentHome: boolean) {
        client('api/sub-shifts/confirm-sent-home/', { body: { appointment_id: id, was_sent_home: sentHome } })
            .then(() => refreshReasons())
            .catch(consoleLogInDev);
    }

    return (
        <Stack gap="md">
            <Stack gap="sm">
                <Title size="h2">Workers Marked Sent Home ({overallReasons.length})</Title>
                <Text size="sm">Please confirm if you sent these workers home.</Text>
            </Stack>
            <Grid columns={3} collapseAt="sm" gap="md">
                {overallReasons.map((x) => (
                    <Card key={x.id}>
                        <Stack gap="sm">
                            <Text>
                                <b>Name:</b> {x.provider_name}
                            </Text>
                            <Text>
                                <b>Shift Date:</b> {formatMonthDayYearWith12HourTime(x.start_date, x.timezone)}
                            </Text>
                            <Row gap="md" align="center" wrap>
                                <PillButton onClick={() => onConfirmOrDenyClick(x.id, true)}>
                                    I sent them home
                                </PillButton>
                                <Link onClick={() => onConfirmOrDenyClick(x.id, false)}>They did not show</Link>
                            </Row>
                            <Row justify="end">
                                <Link
                                    onClick={() => {
                                        setDisputeId(x.id);
                                        setDisputeName(x.provider_name);
                                    }}
                                    color={Colors.accent}
                                >
                                    Dispute
                                </Link>
                            </Row>
                        </Stack>
                    </Card>
                ))}
            </Grid>
            <SentHomeDisputeModal
                small={isXs}
                isOpen={Boolean(disputeId)}
                onClose={() => {
                    setDisputeId(undefined);
                    setDisputeName('');
                }}
                onSubmit={() => {
                    setDisputeId(undefined);
                    refreshReasons();
                }}
                appointmentId={disputeId}
                workerName={disputeName}
            />
        </Stack>
    );
}
